export default __webpack_public_path__ + "static/card-2-d4c26ee8401a58b06ae00a98f793b489.png";